import { $$ } from 'utils/dom';
import { PictureLazerLoader } from 'modules/lazer-loader';

// Lazy load images
const pictures = $$('.o-grid-list__item picture[data-lazerload]');

if (pictures.length) {
  new PictureLazerLoader({
    targets: pictures,
    config: {
      rootMargin: '50px 0px',
      threshold: 0.01,
    },
    cb: ({ target }) => target.setAttribute('data-lazerload', 'loaded'),
  }).init();
}
